__turbopack_context__.v({
  "className": "ibm_plex_mono_74a75947-module__1LWp-W__className",
  "variable": "ibm_plex_mono_74a75947-module__1LWp-W__variable",
});
